export default __webpack_public_path__ + "static/media/IconDesc_Engine.256.7e630440.png";